import { resolveMentionIcon } from "src/base-components/Chat/mentionIconRegistry";
import { Pill, resolvePillVariant } from "src/base-components/Pill";

type Props = React.HTMLAttributes<HTMLElement> & {
  "data-mention-id"?: string;
  "data-mention-icon"?: string;
  "data-mention-variant"?: string;
};

export const TktlMention: React.FC<Props> = ({ children, ...attrs }) => {
  const mentionId = attrs["data-mention-id"];
  const icon = resolveMentionIcon(attrs["data-mention-icon"]);
  const variant = resolvePillVariant(attrs["data-mention-variant"]);

  if (!mentionId) {
    return <>{children}</>;
  }

  return (
    <Pill
      size="sm"
      data-mention-id={mentionId}
      data-loc={`mention-${mentionId}`}
      variant={variant}
    >
      {icon && <Pill.Icon icon={icon} />}
      <Pill.Text>{children}</Pill.Text>
    </Pill>
  );
};
